// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"730f6629","230":"8c18f761","270":"252368f7","436":"0bc8b848","495":"5978ecc7","593":"f3ae56b8","631":"67bd41cb","720":"a5354c73","877":"58cfccee"}[chunkId] + ".chunk.js";
};